import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";

export default function MostSendCertificate() {
  const [chartData, setChartData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const COLORS = [
    "#0088FE", // 🔵 Blue
    "#00C49F", // 🟢 Teal
    "#FFBB28", // 🟡 Yellow
    "#FF8042", // 🟠 Orange
    "#AF19FF", // 🟣 Purple
    "#FF4560", // 🔴 Red
    "#1E90FF", // 🔵 Dodger Blue
    "#2ECC71", // 🟢 Green
    "#F39C12", // 🟡 Amber
    "#8E44AD", // 🟣 Deep Purple
    "#E74C3C", // 🔴 Crimson
    "#3498DB", // 🔵 Light Blue
    "#16A085", // 🟢 Jade
    "#D35400", // 🟠 Burnt Orange
    "#7F8C8D", // ⚪ Gray
    "#9B59B6", // 🟣 Lavender
    "#27AE60", // 🟢 Emerald
    "#2980B9", // 🔵 Denim
    "#E67E22", // 🟠 Carrot
    "#C0392B", // 🔴 Brick
  ];

  useEffect(() => {
    const fetchGraphData = async () => {
      try {
        const res = await axios.get(
          `/get-mostly-sent-certificate?startDate=${startDate}&endDate=${endDate}`,
          adminConfig()
        );
        const { data } = res.data;
        setChartData(data);
      } catch (err) {
        console.error("Failed to load chart data", err);
      }
    };

    fetchGraphData();
  }, [startDate, endDate]);

  return (
    <div className="mb-5">
      <h1>Most Send Certificates</h1>
      <div className="filter_section mt-5">
        <div className="input-group filter_fields">
          <Form.Group controlId="formBasicEmail" className="dt_range">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={selectedStartDate}
              max={selectedEndDate || moment().format("YYYY-MM-DD")}
              onChange={(e) => setSelectedStartDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="formBasicEmail" className="dt_range">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={selectedEndDate}
              min={selectedStartDate}
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => setSelectedEndDate(e.target.value)}
            />
          </Form.Group>

          <Button
            className="search_button"
            variant="primary"
            onClick={() => {
              setStartDate(selectedStartDate);
              setEndDate(selectedEndDate);
            }}
          >
            Search
          </Button>

          <Button
            className="search_button"
            variant="secondary"
            onClick={() => {
              setSelectedStartDate("");
              setSelectedEndDate("");
              setStartDate("");
              setEndDate("");
            }}
          >
            Clear Filter
          </Button>
        </div>
      </div>

      <Card style={{ borderRadius: "10px" }}>
        <Card.Body>
          <Row className="align-items-center justify-content-center">
            <Col md="4">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={chartData}
                    dataKey="count"
                    nameKey="certificateTitle"
                    cx="50%"
                    cy="50%"
                    outerRadius={150}
                    fill="#8884d8"
                    labelLine={false}
                    label={renderCustomizedLabel}
                  >
                    {chartData.map((_, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Col>
            <Col md="4">
              <CustomLegend data={chartData} colors={COLORS} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  value,
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {value}
    </text>
  );
};

const CustomLegend = ({ data, colors }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        marginTop: "1rem",
      }}
    >
      {data.map((entry, index) => (
        <div
          key={`legend-${index}`}
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              backgroundColor: colors[index % colors.length],
              marginRight: 8,
              borderRadius: 4,
            }}
          ></div>
          <span>{entry.certificateTitle}</span>
        </div>
      ))}
    </div>
  );
};
